export default __webpack_public_path__ + "static/media/wcd.b3ce4c59.jpeg";